export const IOS = 'iOS';
export const ANDROID = 'Android';
export const CHROME = 'Chrome';
export const SAFARI = 'Safari';
export const MOBILE_SAFARI = 'Mobile Safari';

export const IOS_MIN_VERSION = 14.3;
export const ANDROID_MIN_VERSION = 7;
export const CHROME_MIN_VERSION = 59;
